import request from '@/utils/request'

/**
 * 获取控制中心统计信息(含日环比)
 */
export function getDashboardStatistics() {
  return request({
    url: '/api/dashboard/statistics',
    method: 'get'
  })
}

/**
 * 获取增长趋势(用户/设备/智能体/数字藏品/NFC/徽章/AI对话新增量)
 * @param {Object} params { dimension, timeRange, granularity, startDate, endDate, memorialId, memorialType }
 */
export function getGrowthTrend(params) {
  return request({
    url: '/api/dashboard/growth-trend',
    method: 'get',
    params
  })
}

/**
 * 获取纪念徽章列表(返回全部已发布徽章, 用于徽章趋势按徽章筛选)
 */
export function getBadgeTypes() {
  return request({
    url: '/api/dashboard/badge-types',
    method: 'get'
  })
}

/**
 * 活动阶段对比
 * @param {Object} params { stages, startDate, endDate, metrics }
 */
export function getStageComparison(params) {
  return request({
    url: '/api/dashboard/stage-comparison',
    method: 'get',
    params
  })
}

/**
 * 转化漏斗
 * @param {Object} params { funnelType, startDate, endDate, window }
 */
export function getFunnel(params) {
  return request({
    url: '/api/dashboard/funnel',
    method: 'get',
    params
  })
}

/**
 * 漏斗层用户列表(下钻)
 * @param {Object} params { funnelType, layer, startDate, endDate, page, limit }
 */
export function getFunnelUsers(params) {
  return request({
    url: '/api/dashboard/funnel-users',
    method: 'get',
    params
  })
}

/**
 * NFC刷卡时段分布(24小时直方图, 与趋势卡片时间范围联动)
 * @param {Object} params { timeRange, startDate, endDate }
 */
export function getNfcHourlyDist(params) {
  return request({
    url: '/api/dashboard/nfc-hourly-dist',
    method: 'get',
    params
  })
}

/**
 * 用户属性画像分布(全量口径: 等级/积分余额/设备持有/近12月注册趋势)
 */
export function getUserProfileDistribution() {
  return request({
    url: '/api/dashboard/user-profile-distribution',
    method: 'get'
  })
}

/**
 * 积分与权益分析(KPI/每日获取消耗趋势/流转结构/兑换排行/兑换漏斗/过期预警)
 * @param {Object} params { timeRange, startDate, endDate }
 */
export function getPointsAnalysis(params) {
  return request({
    url: '/api/dashboard/points-analysis',
    method: 'get',
    params
  })
}

/**
 * 徽章获取来源分布(按徽章类型分组的发放量堆叠趋势)
 * @param {Object} params { timeRange, startDate, endDate }
 */
export function getBadgeSourceDist(params) {
  return request({
    url: '/api/dashboard/badge-source-dist',
    method: 'get',
    params
  })
}

/**
 * 用户留存矩阵
 * @param {Object} params { days, offsets }
 */
export function getRetention(params) {
  return request({
    url: '/api/dashboard/retention',
    method: 'get',
    params
  })
}

/**
 * 用户行为分层
 * @param {Object} params { startDate, endDate }
 */
export function getUserSegmentation(params) {
  return request({
    url: '/api/dashboard/user-segmentation',
    method: 'get',
    params
  })
}

/**
 * 用户行为组合占比(全量口径, 不受时间范围限制)
 */
export function getUserBehaviorCombo() {
  return request({
    url: '/api/dashboard/user-behavior-combo',
    method: 'get'
  })
}

/**
 * 通用排行
 * @param {Object} params { dimension, seriesId, topN, startDate, endDate }
 */
export function getRanking(params) {
  return request({
    url: '/api/dashboard/ranking',
    method: 'get',
    params
  })
}

/**
 * 系列分析(指标卡片 + 单品收藏人数 + 用户持有数量分层)
 * @param {Object} params { seriesId, startDate, endDate }
 */
export function getSeriesAnalysis(params) {
  return request({
    url: '/api/dashboard/series-analysis',
    method: 'get',
    params
  })
}

/**
 * 设备活跃度分析(按末次连接距今天数分层)
 */
export function getDeviceActivity() {
  return request({
    url: '/api/dashboard/device-activity',
    method: 'get'
  })
}

/**
 * 设备图表(固件版本分布 + 改名状态 + 用户持有设备数分布 + OTA升级渗透率)
 */
export function getDeviceCharts() {
  return request({
    url: '/api/dashboard/device-charts',
    method: 'get'
  })
}

/**
 * 日活用户分析(DAU趋势/渠道贡献/KPI/留存活跃评估)
 * @param {Object} params { timeRange, startDate, endDate }
 */
export function getUserActivity(params) {
  return request({
    url: '/api/dashboard/user-activity',
    method: 'get',
    params
  })
}
